import React from 'react';
import PropTypes from 'prop-types';
import { HeadingWrapper, HeadingWrapperLink, ProductsHeaderContainer } from './ProductsHeader.css';
import SortAndPagination from '../SortAndPagination';

const ProductsHeader = ({
  s3BasePath,
  handleSortChange,
  currentSorting,
  handleOffsetChange,
  paginationOffset,
  text,
  textLink,
  totalProducts
}) => (
  <div>
    <ProductsHeaderContainer>
      <HeadingWrapper data-cy="page-title">
        {text} {textLink && <HeadingWrapperLink href={textLink}>[EDIT]</HeadingWrapperLink>}
      </HeadingWrapper>
      {totalProducts !== 0 && (
        <SortAndPagination
          paginationOffset={paginationOffset}
          totalProducts={totalProducts}
          handleOffsetChange={handleOffsetChange}
          handleSortChange={handleSortChange}
          currentSorting={currentSorting}
          s3BasePath={s3BasePath}
        />
      )}
    </ProductsHeaderContainer>
  </div>
);

ProductsHeader.propTypes = {
  text: PropTypes.string,
  textLink: PropTypes.string,
  totalProducts: PropTypes.number.isRequired,
  handleOffsetChange: PropTypes.func.isRequired,
  paginationOffset: PropTypes.number.isRequired,
  handleSortChange: PropTypes.func.isRequired,
  s3BasePath: PropTypes.string.isRequired,
  currentSorting: PropTypes.string.isRequired
};

export default ProductsHeader;
